// extracted by mini-css-extract-plugin
export default {"link":"styles_link__CPxBp","filteredTitle":"styles_filteredTitle__rbdVC"};